import React from 'react'
import { useTranslation } from 'react-i18next';

const SearchLoading = () => {
    const {t} = useTranslation();

    return (
        <div className='d-flex flex-column align-items-center justify-content-center'>
            <img src='/assets/img/loading.svg' style={{width: '60px'}} alt="loading" />
            <h6 className='text-center' style={{fontSize: '.8rem', marginTop: '.5rem'}}> {t("searching")} </h6>
        </div>
    )
}

export default SearchLoading
